import React, { useState } from "react";
import useDocumentList from "../../hooks/useDocumentList";
import InvoiceDataGrid from "../invoiceList/InvoiceDataGrid";
import InvoiceActivityLogs from "../invoiceList/InvoiceActivityLogs";
import DocumentHeader from "../invoiceList/DocumentHeader";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const SalesReturnList = () => {
  const [p1Value, setP1Value] = useState("ALL");
  const [modalType, setModalType] = useState(null);

  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    exportDocumentList,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList,
  } = useDocumentList({
    docType: "SRET",
    docLabel: "Sales Return List",
    p1Value,
    p2Value: "-",
    docNoField: "SR_NO",
    editRoute: "/sales_return",
    screenCode: "SRTCOUNT",
    initialSearchType: "-",
  });
  const handleExport = () => {
    exportDocumentList();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DocumentHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title={"Sales Return List"}
        searchTerm={searchTerm}
        searchType={searchType}
        setSearchTerm={setSearchTerm}
        setSearchType={setSearchType}
        filteredDocs={documentData}
        showType={p1Value}
        setShowType={setP1Value}
        total={totalCount}
        onExport={handleExport}
        documentType={"SALES_RETURN"}
        config={config}
        selectedRowData={selectedRowData}
        doctype="SR_NO"
        showFilter={false}
      />
      <div className="max-w-full mx-auto py-2 space-y-4">
        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <InvoiceActivityLogs
              invoiceId={selectedRowData["SR_NO"]}
              COMPANY_CODE={config.COMPANY_CODE}
              BASE_URL={config.BASE_URL}
              modificationType={"SRETTIMELINE"}
              printType={"SRETPRINTTIMELINE"}
              DEPARTMENT={config.DEPARTMENT_NO}
            />
          )}
          <div
            className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
              } transition-all duration-300`}
          >
            <InvoiceDataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              onView={handleView}
              columnVisibilityModel={columnVisibilityModel}
              setColumnVisibilityModel={setColumnVisibilityModel}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentStart={currentStart}
              currentEnd={currentEnd}
              totalCount={totalCount}
              showSidebar={showSidebar}
              docLabel={"SR"}
              enableF5Action={false}
              config={config}
              refreshDocumentList={refreshDocumentList}
              modalType="close"
              setModalType={setModalType}
              showEdit={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("-AY")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesReturnList;
